export default {
  src: 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js',
  autoBlockSrc:
    'https://cdn.cookielaw.org/consent/2f382011-c7a0-4e50-bf7e-a229d0dfbae6-test/OtAutoBlock.js',
  domainScript: '2f382011-c7a0-4e50-bf7e-a229d0dfbae6-test',
};
